import { baseUrl } from '@/config/env';
import request from '@/router/axios';
import { parseParam } from '@/util/util';

export const findClassify = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-sales/v1/classify/agent?`+params,
        method: 'GET'
    })
}

export const findClassifyAll = () => {
    return request({
        url: `${baseUrl}/joins-sales/v1/classify/choose/agent`,
        method: 'GET'
    })
}

export const addClassify = (data) => {
    return request({
        url: `${baseUrl}/joins-sales/v1/classify/agent`,
        method: 'POST',
        data: data
    })
}

export const editClassify = (data) => {
    return request({
        url: `${baseUrl}/joins-sales/v1/classify/agent`,
        method: 'PUT',
        data: data
    })
}

export const delClassify = (deleteOption, ids) => {
    let temp = ids.join(",")
    return request({
        url: `${baseUrl}/joins-sales/v1/classify/agent/${temp}?option=${deleteOption}`,
        method: 'DELETE'
    })
}
export const chooseSecondClassify = (id) => {
    return request({
        url: `${baseUrl}/joins-sales/v1/classify/choose?superiorId=${id}`,
        method: 'GET'
    })

}